import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useCarEventsStore = defineStore('car-events', () => {

    const configStore   = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore    = useTokenStore()

    const eventsCar = ref([])
    const eventsCarPart = ref(null)
    const eventsCarPartMsg = ref({})
    const eventsCarPartProcess = ref(false)

    /**
     * Получает события выбранного автомобиля
     * 
     * @param {Object} payload 
     */
    async function readEventsCar(payload) {

        eventsCarPartProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/events${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {

                request.array.map( event => {
                    event.type_key = 'EVENT_' + event.type.toUpperCase()
                })

                eventsCarPart.value = request
                eventsCarPartMsg.value = { success: true }

            } else {

                eventsCarPart.value = {}
                eventsCarPartMsg.value = { success: false, text: request.error }
            }

        } else {
            eventsCarPartMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        eventsCarPartProcess.value = false
    }

    const setEventsCar                      = data => eventsCar.value                       = data
    const setEventsCarPart                  = data => eventsCarPart.value                   = data
    const setEventsCarPartMsg               = data => eventsCarPartMsg.value                = data

    return {

        configStore,
        requestsStore,
        tokenStore,
        eventsCar,
        eventsCarPart,
        eventsCarPartMsg,
        eventsCarPartProcess, 
        readEventsCar,
        setEventsCar, 
        setEventsCarPart, 
        setEventsCarPartMsg 
    }
})
